export default __webpack_public_path__ + "static/media/COC-icon.075d7edf.svg";